/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { DocumentTypeWithLinks } from '../models/document-type-with-links';
@Injectable({
  providedIn: 'root',
})
class DocumentTypesWithLinksService extends __BaseService {
  static readonly DocumentTypesWithLinksGetPath = '/document-types-with-links/{documentTypeId}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Returns the document type with links
   * @param params The `DocumentTypesWithLinksService.DocumentTypesWithLinksGetParams` containing the following parameters:
   *
   * - `documentTypeId`: GUID of the document type
   *
   * - `Authorization`: Bearer JSON Web Token
   *
   * @return OK
   */
  DocumentTypesWithLinksGetResponse(params: DocumentTypesWithLinksService.DocumentTypesWithLinksGetParams): __Observable<__StrictHttpResponse<DocumentTypeWithLinks>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/document-types-with-links/${encodeURIComponent(String(params.documentTypeId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DocumentTypeWithLinks>;
      })
    );
  }
  /**
   * Returns the document type with links
   * @param params The `DocumentTypesWithLinksService.DocumentTypesWithLinksGetParams` containing the following parameters:
   *
   * - `documentTypeId`: GUID of the document type
   *
   * - `Authorization`: Bearer JSON Web Token
   *
   * @return OK
   */
  DocumentTypesWithLinksGet(params: DocumentTypesWithLinksService.DocumentTypesWithLinksGetParams): __Observable<DocumentTypeWithLinks> {
    return this.DocumentTypesWithLinksGetResponse(params).pipe(
      __map(_r => _r.body as DocumentTypeWithLinks)
    );
  }
}

namespace DocumentTypesWithLinksService {

  /**
   * Parameters for DocumentTypesWithLinksGet
   */
  export interface DocumentTypesWithLinksGetParams {

    /**
     * GUID of the document type
     */
    documentTypeId: string;

    /**
     * Bearer JSON Web Token
     */
    Authorization: string;
  }
}

export { DocumentTypesWithLinksService }